import en from "./locale/en.json";
import ar from "./locale/ar.json";

const resources = { en, ar };

export default resources;
